/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gdpr_Tab_SubjectsInputs */

const cs_gdpr_tab_subjects = /** @type {(inputs: Gdpr_Tab_SubjectsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Žádosti subjektů`)
};

const en_gdpr_tab_subjects = /** @type {(inputs: Gdpr_Tab_SubjectsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subject requests`)
};

/**
* | output |
* | --- |
* | "Subject requests" |
*
* @param {Gdpr_Tab_SubjectsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gdpr_tab_subjects = /** @type {((inputs?: Gdpr_Tab_SubjectsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gdpr_Tab_SubjectsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gdpr_tab_subjects(inputs)
	return cs_gdpr_tab_subjects(inputs)
});